function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import queryString from 'qs';
var buildUrl = (searchQuery, _ref) => {
  var pageTemplate = _ref.pageTemplate;
  return searchQuery.toSearchUrl(pageTemplate && {
    pageTemplate: '{{ page }}'
  });
};
var localityToUrl = (key, list) => ({
  [key]: list ? list.join(',') : undefined
});
export var buildUrlFromLocalities = localities => {
  var localityMap = localities.reduce((grouped, locality) => {
    /* eslint-disable-next-line no-param-reassign */
    (grouped[locality.type] = grouped[locality.type] || []).push(locality.slug);
    return grouped;
  }, {});
  return "?".concat(queryString.stringify(_objectSpread(_objectSpread(_objectSpread({}, localityToUrl('suburb', localityMap.DIVISION)), localityToUrl('district', localityMap.DISTRICT)), localityToUrl('region', localityMap.REGION)), {
    arrayFormat: 'comma'
  }));
};
export default buildUrl;